export default __webpack_public_path__ + "static/media/about-team-14.48f1d179.jpg";